import React, { memo, useMemo } from 'react';
import { styled } from 'linaria/react';
import { DelayedContent } from '../delayed-content';

const DATA_QA_SKELETON = 'skeleton';

type SkeletonProps = {
  width?: string;
  height?: string;
  blink?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Skeleton: React.FC<SkeletonProps> = memo(
  ({ className = '', width, height, style, blink = true, ...rest }) => {
    const styles: React.CSSProperties = useMemo(
      () => ({
        ...style,
        ...(width && { width }),
        ...(height && { height }),
      }),
      [width, height, style],
    );

    return (
      <DelayedContent>
        <SkeletonItem
          className={className}
          style={styles}
          blink={blink}
          data-qa={DATA_QA_SKELETON}
          {...rest}
        />
      </DelayedContent>
    );
  },
);

const SkeletonItem = styled.div<React.HTMLAttributes<HTMLDivElement> & { blink: SkeletonProps['blink'] }>`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: var(--color-primary-20);
  background-image: linear-gradient(
    90deg,
    var(--color-primary-20),
    var(--color-bg) 300px,
    var(--color-primary-20)
  );
  background-repeat: no-repeat;
  background-position-x: -600px;
  background-size: 600px 100%;
  animation: 1.2s cubic-bezier(0.4, 0, 0.2, 1) 0s infinite normal none running gradient-flow;
  animation-play-state: ${({ blink }) => (blink ? 'running' : 'paused')};
  will-change: background-position;
  contain: strict;
  @keyframes gradient-flow {
    0% {
      background-position-x: -612px;
    }
    100% {
      background-position-x: 434px;
    }
  }
`;
